import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormTextField } from '@/components/Form/FormTextField/FormTextField';
import { useDcrFields } from '@/features/DataChangeRequest/_constants/useDcrFields';
import type { OrganizationalSectionValuesIn } from '@/features/DataChangeRequest/_schemas/HcoSchemas/OrganizationalSection.validation';
import { DcrFormController } from '@/features/DataChangeRequest/DcrFormController/DcrFormController';
import { FormSection } from '@/features/DataChangeRequest/DcrModal/FormSection/FormSection';

export const HcoIdsSection = () => {
	const { t } = useTranslation();
	const { hcoFields } = useDcrFields();
	const {
		control,
		formState: { dirtyFields }
	} = useFormContext<OrganizationalSectionValuesIn>();
	const section = 'ids';

	return (
		<FormSection title={t('IDs')} id={section}>
			<DcrFormController
				name='nhidCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='nhidCda_V'
						label={hcoFields.nhidCda_V.label}
						name={field.name}
						defaultValue={(field.value ?? '') as string}
						indicateError={fieldState.error ? true : false}
						isDirty={!!dirtyFields.nhidCda_V}
						onChange={field.onChange}
					/>
				)}
			/>

			<DcrFormController
				name='hcoTaxId_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='hcoTaxId_V'
						label={hcoFields.hcoTaxId_V.label}
						name={field.name}
						defaultValue={(field.value ?? '') as string}
						indicateError={fieldState.error ? true : false}
						isDirty={!!dirtyFields.hcoTaxId_V}
						onChange={field.onChange}
					/>
				)}
			/>
		</FormSection>
	);
};
